var map = {
	"./ambassador.png": "6ce3",
	"./diamond.png": "6231",
	"./diamond_elite.png": "923b",
	"./double_diamond.png": "79cc",
	"./double_star.png": "1dba",
	"./expert.png": "9b15",
	"./grand_diamond.png": "0256",
	"./star.png": "afa3",
	"./start.png": "ba32",
	"./v_president.png": "2b38"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e15d";